import { FacebookMessengerIcon, FacebookMessengerShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import React from 'react';
import { LinkShareTypes } from './consts';
import Icon from '../../generic-components/Icon';

interface IProps {
  type: LinkShareTypes;
  subjectMsg: string;
  bodyMsg: string;
  paymentUrl: string;
  icon: string;
}

export const ShareButtons = ({ type, bodyMsg, paymentUrl, subjectMsg, icon }: IProps) => {
  const message = `${subjectMsg} ${bodyMsg}`;
  const returnButton = () => {
    if (type === LinkShareTypes.Email) {
      return <Icon className='object-contain' src={icon} />;
    }
    if (type === LinkShareTypes.Facebook) {
      return (
        <FacebookMessengerShareButton url={paymentUrl} title={message} appId=''>
          <FacebookMessengerIcon size={48} round />
        </FacebookMessengerShareButton>
      );
    }
    if (type === LinkShareTypes.WhatsApp) {
      return (
        <WhatsappShareButton url={paymentUrl} title={message} separator='::' className=''>
          <WhatsappIcon size={48} round />
        </WhatsappShareButton>
      );
    }
    if (type === LinkShareTypes.IMessage) {
      return <Icon className='object-contain' src={icon} />;
    }
    return null;
  };

  return <>{returnButton()}</>;
};
